// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1761 ? "d0deef33" : chunkId) + "." + {"1761":"1fe3afdf5d5ad41b","2172":"752309808d6c0e82","5316":"66c7b61691d8131d","7749":"887128b8813597cb","8028":"9c3ab17ce13d974d"}[chunkId] + ".js";
};